import { get, post } from './utils';

export async function getAllotificationsApi(data) {
  return post(`/api/notification/search`, data);
}
